import React from "react";
import { Search, X } from "lucide-react";

const SearchInputWithClear = ({
  value,
  onChange,
  onClear,
  placeholder,
  className = "flex-1 relative",
  inputClassName = "w-full pl-10 pr-9 py-2.5 bg-slate-50 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-xl text-sm text-slate-800 dark:text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500",
  iconLeft = "left-3",
  testId,
}) => {
  const handleClear = () => {
    if (onClear) onClear();
    else onChange({ target: { value: "" } });
  };

  return (
    <div className={className}>
      <Search
        className={`pointer-events-none absolute ${iconLeft} top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400`}
      />
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        data-testid={testId}
        className={inputClassName}
      />
      {value && (
        <button
          type="button"
          onClick={handleClear}
          aria-label="Clear search"
          className="absolute right-2 top-1/2 -translate-y-1/2 rounded-md p-0.5 text-slate-400 hover:text-slate-700 dark:hover:text-slate-200 transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
};

export default SearchInputWithClear;
